import script from "./CourseContentHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseContentHeader.vue?vue&type=script&setup=true&lang=js"

import "./CourseContentHeader.vue?vue&type=style&index=0&id=7fb37ea8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fb37ea8"]])

export default __exports__